// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { createApp } from './App';

Vue.config.productionTip = false;

// eslint-disable-next-line no-unused-vars
const { app, router } = createApp();

router.onReady(() => {
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    let diffed = false;
    const activated = matched.filter((c, i) => {
      return diffed || (diffed = (prevMatched[i] !== c));
    });
    const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _);
    if (!asyncDataHooks.length) {
      return next();
    }

    Promise.all(asyncDataHooks.map(hook => hook({ route: to })))
        .then(next)
        .catch(next);
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.reuse === false)) {
      app.key = to.path;
    } else {
      app.key = null;
    }
    next();
  });
});



// WEBPACK FOOTER //
// ./src/main.js